import './Preview.scoped.scss'
import { useAct } from 'FlowBuilder/store'

function useHtmlContentHash() {
  return useSel(s => {
    const ft = s.builder.flowTemplate || {}
    const flow = s.builder.flow || {}
    return [
      ft.headHtml || '',
      ft.bodyHtml || '',
      ft.stylesCss || '',
      ft.additionalHead || '',
      ft.additionalCss || '',
      flow.additionalHead || '',
      flow.additionalCss || '',
    ].join('|||')
  })
}

export default function Preview2() {
  const act = useAct()
  const previewUrl = useSel(s => s.builder.flow.previewUrl)

  const mobile = useSel((s) => s.local.mobile)
  const iframeRef = useRef()

  const htmlContentHash = useHtmlContentHash()
  const [iframeKey, setIframeKey] = useState(0)
  const initialRenderRef = useRef(true)
  const debouncedRemountRef = useRef(null)

  // Debounced remount when HTML content changes
  useEffect(() => {
    if (initialRenderRef.current) {
      initialRenderRef.current = false
      return
    }

    if (debouncedRemountRef.current) {
      clearTimeout(debouncedRemountRef.current)
    }

    debouncedRemountRef.current = setTimeout(() => {
      setIframeKey(k => k + 1)
    }, 1500)

    return () => {
      if (debouncedRemountRef.current) {
        clearTimeout(debouncedRemountRef.current)
      }
    }
  }, [htmlContentHash])

  useEffect(() => {
    function syncData({ force = false } = {}) {
      const iframe = iframeRef.current
      act.builder.syncPreview({ iframe, force })
    }

    const interval = setInterval(syncData, 1000)
    syncData() // initial sync

    // add message handling
    const handleMessage = (event) => {
      if (event.data.type === 'FIELD_EDIT_CLICK') {
        const { field, slug, actionId } = event.data.payload

        act.local.setModal({ kind: 'editContent', fieldKind: field.fieldKind, slug, actionId, wysiwyg: field.wysiwyg })
      } else if (event.data.type === 'FLOW_TAKER_READY') {
        syncData({ force: true })
      }
    }
    window.addEventListener('message', handleMessage)

    // Cleanup
    return () => {
      clearInterval(interval)
      window.removeEventListener('message', handleMessage)
    }
  }, [iframeKey])

  // Allow cypress to access sandboxed iframe content
  const sandbox = window.ENV.CYPRESS
    ? 'allow-scripts allow-popups allow-same-origin'
    : 'allow-scripts allow-popups'

  return <div className={mobile ? 'outer mobile' : 'outer desktop'}>
    <div className='mobile-wrapper'>
      <iframe key={iframeKey} sandbox={sandbox} src={previewUrl} className='preview' ref={iframeRef} />
    </div>
  </div>
}
